import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MutationButton from '../buttons/MutationButton';
import { extendedMutationType, uiPhaseType } from '../../types';
import { joinClassNames } from '../../utils';

AuctionTransitionButton.propTypes = {
    fromPhase: uiPhaseType.isRequired,
    extendedMutation: extendedMutationType.isRequired,
    confirmationMessage: PropTypes.string.isRequired,
    toPhase: uiPhaseType.isRequired,
    extraConfirmationMessage: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

AuctionTransitionButton.defaultProps = {
    extraConfirmationMessage: null,
    className: null,
    disabled: false,
};

function AuctionTransitionButton(props) {
    const {
        fromPhase,
        extendedMutation,
        confirmationMessage,
        extraConfirmationMessage,
        toPhase,
        className,
        disabled,
    } = props;
    const { t } = useTranslation();
    const { id, icon, fromPhases } = toPhase;
    return (
        fromPhases.includes(fromPhase) && (
            <MutationButton
                className={joinClassNames(className, 'button-bordered-orange', 'button')}
                confirmationMessage={confirmationMessage}
                extraConfirmationMessage={extraConfirmationMessage}
                extendedMutation={extendedMutation}
                disabled={disabled}
                showConfirmationDialog
            >
                <FontAwesomeIcon icon={icon} />&nbsp;{t(`auctions.phase.${id}.transition-action`)}
            </MutationButton>
        )
    );
}

export default AuctionTransitionButton;
